import classNames from 'classnames';
import React from 'react';

import { getTranslation, keys } from '../../../../Resources/Translations';

interface IErrorMessageBar {
    message: string | null;
    onClose: () => void;
}

export const ErrorMessageBar = (props: IErrorMessageBar) => {
    return (
        <div className={classNames('ErrorMessageBar', !!props.message && 'ErrorMessageBar--Visible')}>
            <div className="ErrorMessageBar__Inner">
                <span className="ErrorMessageBar__Icon" />
                <div className="ErrorMessageBar__Content">
                    <div className="ErrorMessageBar__Text" role="alert">
                        {props.message}
                    </div>
                </div>
                <button className="ErrorMessageBar__CloseButton" type="button" onClick={props.onClose}>
                    <span className="visuallyHidden">{getTranslation(keys['errorMessageBar.close'])}</span>
                </button>
            </div>
        </div>
    );
};
